
// import Clipboard from 'clipboard'
import DetailMsg from '../components/detail/Msg'
import DetailPage from '../components/detail/DetailPages'
import DetailFile from '../components/detail/File'
import DetailDefaultFile from '../components/detail/DefaultFile'
import XHeader from 'vux/src/components/x-header/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
  name: 'app',
  directives: {
    TransferDom
  },
  components: {
    DetailMsg,
    DetailFile,
    DetailDefaultFile,
    DetailPage,
    XHeader,
    ButtonTab,
    ButtonTabItem,
    Group,
    Cell,
    Flow,
    FlowState,
    FlowLine,
    XImg,
    XInput,
    XButton,
    XTable,
    Previewer,
    XDialog,
    Checker,
    CheckerItem,
    Confirm,
    Flexbox,
    FlexboxItem
  },
  data () {
    return {
      pageTitle: '详情',
      headerBackStatus: true, // 页首返回按钮是否显示，推送跳入时使用
      listShow: true, // 详情列表tab
      msgShow: false, // 流程意见tab
      fileShow: false, // 查看附件tab
      defaultFileShow: false, // 动态通用-查看附件tab
      id: '', // 业务id（taskId）
      flowId: '', // 流程id
      tab: '', // 业务分类name
      auditData: [], // 流程意见-审核
      fileData: [], // 附件
      fileUrl: '', // 附件-文件地址（供复制）
      stepId: '', // 步骤id
      stepCode: '', // 步骤code
      prevFlowNodeId: '', // 上一步节点id
      nextFlowNodeId: '', // 下一步节点id
      nextFlowStepId: '', // 下一步步骤id
      nextFlowNodeArr: [], // 下一步节点集合
      nextFlowStaffArr: [], // 下一步人员集合-角色
      nextFlowStaffValueArr: [], // 下一步人员id集合-角色
      nextFlowStaffTreeArr: [], // 下一步人员id集合-组织架构
      opinion: '', // 审批意见
      fileList: [], // 查看附件-附件地址列表
      filePath: '/wechat/commonFile/downLoadEcmsFile', // 查看附件-访问地址(不含参数)
      baseUrl: '',
      userName: false,
      showToast: false, // 提交弹窗
      confirmBtn: false, // 控制显示、隐藏 确认提交按钮
      checkNodeArr: '', // 审批提交-选择节点 单选
      checkPersonArr: [], // 审批提交-选择人员 可多选

      treeData: [], // 提交-组织结构树
      treeProps: {
        children: 'children',
        label: 'name'
      },
      checkTreeShow: false,
      checkTreeSearchVal: '', // 提交-组织结构树搜索内容
      checkTreeSearchResult: [], // 提交-组织结构树搜索结果

      auditDisable: true, // 同意按钮-disabled
      rejectDisable: false, // 驳回按钮-disabled

      selectedStatus: true
    }
  },
  mounted () {
    this.baseUrl = this.$store.state.url
    if (this.$route.query.isJump) {
      // 点击推送，跳入详情页
      console.log('跳转', this.$route.query)
      this.headerBackStatus = false // 替换返回按钮
      this.baseUrl = this.$route.query.hostAddress
      this.$store.commit('setStateVal', {
        url: this.baseUrl,
        token: this.$route.query.token,
        userName: this.$route.query.account
      })
    }

    if (this.$store.state.userInfo.accounts) {
      this.userName = this.$store.state.userInfo.accounts
    }

    this.pageTitle = this.$route.query.title
    this.id = this.$route.query.id // 业务id
    this.flowId = this.$route.query.flowId // 流程id
    this.tab = this.$route.query.tag // 业务分类name
    this.stepId = this.$route.query.stepId // 当前步骤id

    this.$vux.loading.show({
      text: '加载中'
    })

    this.getFlow() // 流程意见
  },
  methods: {
    goLogin () {
      this.$router.push({ name: 'Login' })
    },
    goTodo () {
      this.$router.push({ name: 'Ecms' })
    },
    changeTab (v) {
      // 切换tab页
      if (v === 1) {
        this.msgShow = false
        this.fileShow = false
        this.defaultFileShow = false
        this.listShow = true
      } else if (v === 2) {
        this.listShow = false
        this.fileShow = false
        this.defaultFileShow = false
        this.msgShow = true
      } else if (v === 3) {
        this.listShow = false
        this.msgShow = false
        this.changeFileCom(this.flowId)
      }
    },
    getFlow () {
      // 获取流程意见数据
      const url = this.baseUrl + '/wechat/wf/' + this.id + '/flowChat?stepId=' + this.stepId
      this.axios({
        url: url,
        method: 'get'
      }).then((response) => {
        let stepsArr = response.data.fc
        let stepsArrL = stepsArr.length
        for (let i = 0; i < stepsArrL; i++) {
          this.auditData.push(stepsArr[i])
        }
        this.getPrevFlow() // 获取上一步
        this.getNextFlow() // 获取下一步
        let flowArr = response.data.si
        if (flowArr) {
          this.stepCode = flowArr[3]
        }
      }).catch((response) => {
        this.$vux.loading.hide()
      })
    },
    changeFileCom: function (v) {
      // 判断是特定待办还是通用待办
      switch (v) {
        // 行政
        case '402880c64423d4cd0144243d69670006':
          this.getFile()
          break
        case '402880744eb4e47f014eb509e7430005':
          this.getFile()
          break
        case 'BUSINESSTRIP':
          this.getFile()
          break
        case '402880c6441ef72101441f7bde9b0006':
          this.getFile()
          break
        case '402880c24490516201449054b8330001':
          this.getFile()
          break
        case 'ASSET_BUY':
          this.getFile()
          break
        // 合同
        case '402880c24581ab53014581bef4260001':
          this.getFile()
          break
        // 财务
        case '5a60eb91d7484075ac18de8f70b9b4b4':
          this.getFile()
          break
        case '4028807450506009015050f267710001':
          this.getFile()
          break
        // case '08c4a7eccfdb4efa9ba2c8c12e8f81fa':
        //   this.getFile()
        //   break
        // case '08c4a7eccfdb4efa9ba2c8c12e8f81fa':
        //   this.getFile()
        //   break
        case '08c4a7eccfdb4efa9ba2c8c12e8f81fa':
          this.getFile()
          break
        // 人力
        case 'PERSON_LUYONG':
          this.getFile()
          break
        case 'POSITIVE_TURNOVER':
          this.getFile()
          break
        case 'LEAVE_JOB':
          this.getFile()
          break
        case 'PERSON_RECRUITMENT':
          this.getFile()
          break
        case 'PEOPLE_CHANGES':
          this.getFile()
          break

        // 业务
        case 'COST1':
          this.getFile()
          break
        case 'COST_BASE':
          this.getFile()
          break
        case '402881e5434d98d801434dd51c3c0001':
          this.getFile()
          break
        case 'BID1':
          this.getFile()
          break
        case '402880e642fe05a20142fe0de6c20001':
          this.getFile()
          break
        case 'SUPERVISE':
          this.getFile()
          break
        case '2218ab49848740f6b4235d5c22882d49':
          this.getFile()
          break

        default:
          this.getDefaultFile()
          break
      }
    },
    getFile () {
      // 获取附件数据
      this.$vux.loading.show({
        text: '加载中'
      })
      this.axios({
        url:
          this.baseUrl + '/wechat/todo/getFiles/' + this.id + '/' + this.flowId,
        method: 'get'
      })
        .then((response) => {
          this.fileShow = true
          this.fileData = response.data.data
          this.$vux.loading.hide()
          this.fileList = [] // 清空
          let fileDataL = this.fileData.length
          for (let i = 0; i < fileDataL; i++) {
            let fileUrl = {
              src:
                this.filePath +
                '?taskId=' +
                this.id +
                '&flowId=' +
                this.flowId +
                '&fileId=' +
                this.fileData[i].fileId,
              type: this.fileData[i].fileType
            }
            this.fileList.push(fileUrl)
          }
          this.fileData = this.fileData.map((item) => ({
            fileSrc: this.filePath + '?taskId=' + this.id + '&flowId=' + this.flowId + '&fileId=' + item.fileId,
            fileType: item.fileType,
            ...item
          }))
        })
        .catch((response) => {
          this.$vux.loading.hide()
        })
    },
    getDefaultFile () {
      // 获取通用待办附件数据
      this.fileData = [] // 清空
      this.$vux.loading.show({
        text: '加载中'
      })
      this.axios({
        url:
          this.baseUrl +
          '/wechat/otherBusiness/' +
          this.id +
          '/files?flowId=' +
          this.flowId,
        method: 'get'
      })
        .then((response) => {
          this.defaultFileShow = true
          this.fileData = response.data
          this.$vux.loading.hide()
          // this.fileList = [];// 清空
          // let fileDataL = this.fileData.length;
          // for(let i=0;i<fileDataL;i++){
          //   let fileUrl = {src:this.filePath+'?taskId='+this.id+'&flowId='+this.flowId+'&fileId='+this.fileData[i].fileId,type:this.fileData[i].fileType};
          //   this.fileList.push(fileUrl);
          // }
        })
        .catch((response) => {
          this.$vux.loading.hide()
        })
    },
    getPrevFlow () {
      // 获取上一步骤
      this.axios({
        url:
          this.baseUrl +
          '/wechat/wf/' +
          this.id +
          '/listPrevFlowNodeInfo?stepId=' +
          this.stepId,
        method: 'get'
      }).then((response) => {
        this.prevFlowNodeId = response.data.rows[0].id
      })
        .catch((response) => {
          this.$vux.loading.hide()
        })
    },
    getNextFlow () {
      // 获取下一步骤
      this.axios({
        url:
          this.baseUrl +
          '/wechat/wf/' +
          this.id +
          '/listNextFlowNodeInfo?stepId=' +
          this.stepId,
        method: 'get'
      }).then((response) => {
        this.$vux.loading.hide()
        this.nextFlowNodeArr = response.data.rows
        this.auditDisable = false // 打开"同意"按钮
      })
        .catch((response) => {
          this.$vux.loading.hide()
        })
    },
    confirmAudit (staffIds) {
      // this.auditDisable = true // 锁住"同意"按钮
      this.confirmBtn = false // 打开"确认提交"按钮
      this.$vux.loading.show({
        text: '正在提交'
      })
      if (this.nextFlowStaffArr.length === 0 && this.checkTreeShow === false) {
        // 不需手选人员
        this.audit(1, this.nextFlowNodeId)
      } else if (
        this.nextFlowStaffArr.length > 0 &&
        this.checkTreeShow === false
      ) {
        // 需手选人员-角色
        this.multipleAudit(1, staffIds)
      } else if (
        this.nextFlowStaffTreeArr.length > 0 &&
        this.checkTreeShow === true
      ) {
        // 需手选人员-组织架构
        this.multipleAudit()
      }
    },
    audit (agree, nodeId) {
      // 提交 不用手选人员
      let opinionStr = this.opinion
      if (opinionStr == '') {
        opinionStr = '同意'
      }

      let auditData = new FormData()
      auditData.append('stepId', this.stepId)
      auditData.append('agree', '1')
      auditData.append('nextFlowNodeId', nodeId)
      auditData.append('opinion', opinionStr)

      this.axios({
        url: this.baseUrl + '/wechat/wf/' + this.id + '/audit',
        method: 'post',
        data: auditData
      })
        .then((response) => {
          this.showToast = false
          this.$vux.loading.hide()
          if (response.data.status === 1) {
            this.showToastMsg(response.data.msg)
            if (this.$route.query.isJump) {
              // 点击推送，跳入详情页
              setTimeout(() => {
                this.$router.push({ name: 'Ecms' })
              }, 2000)
            } else {
              setTimeout(() => {
                this.$router.back(-1)
              }, 2000)
            }
          } else {
            if (response.data.msg != '审批意见不能为空') {
              this.showToastMsg(response.data.msg + '')
            } else {
              this.showToastMsg(response.data.msg)
            }
            this.confirmBtn = true // 打开"确认提交"按钮
            this.auditDisable = false // 打开"同意"按钮
          }
        })
        .catch((response) => {
          this.$vux.loading.hide()
        })
    },
    multipleAudit () {
      // 提交 需要手选人员
      let staffIdsVal = ''
      if (this.nextFlowStaffValueArr.length > 0) {
        staffIdsVal = this.nextFlowStaffValueArr.join(',')
      } else if (this.nextFlowStaffTreeArr.length > 0) {
        staffIdsVal = this.nextFlowStaffTreeArr.join(',')
      }
      let opinionStr = this.opinion
      if (opinionStr == '') {
        opinionStr = '同意'
      }

      let auditData = new FormData()
      auditData.append('stepId', this.stepId)
      auditData.append('agree', '1')
      auditData.append('nextFlowNodeId', this.nextFlowNodeId)
      auditData.append('opinion', opinionStr)
      auditData.append('staffIds', staffIdsVal)

      this.axios({
        url: this.baseUrl + '/wechat/wf/' + this.id + '/audit',
        method: 'post',
        data: auditData
      })
        .then((response) => {
          this.showToast = false
          this.$vux.loading.hide()
          this.showToastMsg(response.data.msg)
          if (response.data.status === 1) {
            if (this.$route.query.isJump) {
              // 点击推送，跳入详情页
              setTimeout(() => {
                this.$router.push({ name: 'Ecms' })
              }, 2000)
            } else {
              setTimeout(() => {
                this.$router.back(-1)
              }, 2000)
            }
          }
        })
        .catch((response) => {
          this.$vux.loading.hide()
        })
    },
    handleAuditReject () {
      const _this = this
      this.$vux.confirm.show({
        // 组件除show外的属性
        title: '确定驳回？',
        onCancel () {
        },
        onConfirm () {
          _this.auditReject()
        }
      })
    },
    auditReject () {
      // 审批-驳回
      this.rejectDisable = true // 锁住"驳回"按钮
      if (this.prevFlowNodeId == '') {
        // 没有上一节点，不可驳回
        this.showToastMsg('请到PC端处理！')
        this.rejectDisable = false // 打开"驳回"按钮
        setTimeout(() => {
          this.$vux.loading.hide()
        }, 1000)
      } else {
        // 有上一节点，可以驳回
        let opinionStr = this.opinion
        if (opinionStr == '') {
          opinionStr = '不同意'
        }

        let auditData = new FormData()
        auditData.append('stepId', this.stepId)
        auditData.append('agree', '0')
        auditData.append('nextFlowNodeId', this.prevFlowNodeId)
        auditData.append('opinion', opinionStr)

        this.$vux.loading.show({
          text: '正在驳回'
        })
        this.axios({
          url: this.baseUrl + '/wechat/wf/' + this.id + '/audit',
          method: 'post',
          data: auditData
        })
          .then((response) => {
            this.$vux.loading.hide()
            this.showToastMsg(response.data.msg)
            if (response.data.status === 1) {
              if (this.$route.query.isJump) {
                // 点击推送，跳入详情页
                setTimeout(() => {
                  this.$router.push({ name: 'Ecms' })
                }, 2000)
              } else {
                setTimeout(() => {
                  this.$router.back(-1)
                }, 2000)
              }
            }
          })
          .catch((response) => {
            this.$vux.loading.hide()
          })
      }
    },
    doSubmit () {
      // 审批-提交 打开节点、人员选择弹窗
      if (
        this.nextFlowNodeArr.length == 1 &&
        this.nextFlowNodeArr[0].openOperatorManualChoose == 0
      ) {
        // 只有一个选择节点且不用手动选择人员
        this.nextFlowNodeId = this.nextFlowNodeArr[0].id
        this.$vux.loading.show({
          text: '正在提交'
        })
        this.audit(1, this.nextFlowNodeId)
      } else {
        // 打开弹窗-手动选择节点
        this.showToast = true
        if (
          this.nextFlowNodeArr.length == 1 &&
          this.nextFlowNodeArr[0].openOperatorManualChoose == 1
        ) {
          // 只有一个选择节点,且需要手动选择人员-默认选择

          let valStr = []
          valStr.push(
            this.nextFlowNodeArr[0].stepId,
            this.nextFlowNodeArr[0].id,
            this.nextFlowNodeArr[0].openOperatorManualChoose,
            this.nextFlowNodeArr[0].todoResolveMode
          )
          this.singleCheck(valStr.join())
        }
      }
    },
    openDialog () {
      const _this = this
      this.$vux.confirm.show({
        // 组件除show外的属性
        title: '确定提交？',
        onCancel () {
        },
        onConfirm () {
          _this.doSubmit()
        }
      })
    },
    singleCheck (value) {
      // 选择节点-单选
      // 获取选中节点下的人员列表
      if (value === '') {
        this.nextFlowStaffArr = []
        this.confirmBtn = false // 隐藏确认提交按钮
      }
      this.checkPersonArr = []
      let checkArr = value.split(',')
      this.nextFlowNodeId = checkArr[1]
      this.nextFlowStepId = checkArr[0]
      let nodeData = {
        stepId: this.stepId,
        nextFlowNodeId: this.nextFlowStepId
      }

      if (checkArr[2] === '1' && checkArr[3] === '1') {
        // 需要手动选择人员,使用角色
        this.nextFlowStaffTreeArr = []
        this.checkTreeShow = false
        this.confirmBtn = false // 隐藏确认提交按钮
        this.axios({
          // 获取人员列表
          url: this.baseUrl + '/wechat/wf/' + this.id + '/listChooseOperator',
          method: 'post',
          data: nodeData,
          transformRequest: [
            function (data) {
              let ret = ''
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  '=' +
                  encodeURIComponent(data[it]) +
                  '&'
              }
              return ret
            }
          ]
        })
          .then((response) => {
            this.nextFlowStaffArr = response.data.staffs
          })
          .catch((response) => {
          })
      } else if (checkArr[2] === '1' && checkArr[3] === '2') {
        // 需要手动选择人员,使用组织架构
        this.checkTreeShow = true
        this.axios({
          url: this.baseUrl + '/wechat/staff/getOrgStaff',
          method: 'get'
        })
          .then((response) => {
            this.treeData = response.data
            if (this.nextFlowStaffTreeArr.length == 0) {
              this.confirmBtn = false // 隐藏确认提交按钮
            }
          })
          .catch((response) => {
            this.$vux.loading.hide()
          })
      } else if (checkArr[2] === '0') {
        // 不用手动选择人员
        this.nextFlowStaffTreeArr = []
        this.checkTreeShow = false
        this.confirmBtn = true // 显示确认提交按钮
        this.nextFlowStaffArr = []
      }
    },
    treeSearch () {
      // 提交-组织架构搜索按钮
      this.checkTreeSearchResult = []
      let checkTreeSearchVal = this.checkTreeSearchVal
      let treeData = this.treeData
      if (checkTreeSearchVal != '') {
        this.getArray(treeData, checkTreeSearchVal)
      }
    },
    getArray (data, name) {
      // 组织架构搜索-递归
      for (var i in data) {
        if (data[i].name == name || data[i].name.indexOf(name) != -1) {
          this.checkTreeSearchResult.push(data[i])
        } else {
          this.getArray(data[i].children, name)
        }
      }
    },
    addToTree (item) {
      // 将搜索结果添加到树
      let CheckedNodes = this.$refs.tree.getCheckedNodes()
      CheckedNodes.push(item)
      this.$refs.tree.setCheckedNodes(CheckedNodes)
      this.checkTreeSearchResult = []
    },
    clearSearchResult () {
      // 清空搜索栏
      this.checkTreeSearchResult = []
    },
    multipleCheck (value) {
      // 选择人员-多选
      this.nextFlowStaffValueArr = value
      if (value.length > 0) {
        this.confirmBtn = true // 显示确认提交按钮
      } else {
        this.confirmBtn = false
      }
    },
    getCheckedNodes () {
      // 审批-组织架构树
      let checkedPersonArr = this.$refs.tree.getCheckedNodes()
      if (checkedPersonArr.length > 0) {
        this.confirmBtn = true // 显示确认提交按钮
      } else {
        this.confirmBtn = false
      }
      let personIdArr = []
      for (let i = 0; i < checkedPersonArr.length; i++) {
        if (checkedPersonArr[i].isParent == false) {
          personIdArr.push(checkedPersonArr[i].id)
        }
      }
      this.nextFlowStaffTreeArr = personIdArr
    },
    showAlert (msg) {
      // alert提示框，3s后消失
      this.$vux.alert.show({
        title: msg
      })
      setTimeout(() => {
        this.$vux.alert.hide()
      }, 3000)
    },
    showToastMsg (msg) {
      // toast提示框，2s后消失
      this.$vux.toast.show({
        text: msg,
        type: 'text',
        position: 'middle',
        width: '50%'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Detail.vue